import React from 'react';
import { Container } from 'react-bootstrap';
import { PRIMARY_RED } from '../constants';
import bynetLogo from '../assets/bynet-logo.png';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5" dir="ltr" style={{ maxWidth: '900px' }}>
      <div style={{ 
        backgroundColor: '#ffffff', 
        padding: '40px', 
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        {/* Header with Logo */}
        <div style={{ 
          borderBottom: `3px solid ${PRIMARY_RED}`, 
          paddingBottom: '20px', 
          marginBottom: '30px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            backgroundColor: '#000000',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px',
            flexShrink: 0
          }}>
            <img 
              src={bynetLogo} 
              alt="Bynet Logo" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          </div>
          <div>
            <h1 style={{ 
              color: PRIMARY_RED, 
              fontSize: '2.5rem', 
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>
              Privacy Policy
            </h1>
            <p style={{ color: '#666', fontSize: '1.1rem' }}>
              Bynet Data Centers Ltd.
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ fontSize: '16px', lineHeight: '1.8', color: '#333' }}>
          
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              1. Introduction
            </h2>
            <p>
              Bynet Data Centers Ltd. ("the Company", "we", "us", "our") is committed to protecting the privacy and security of personal information of users of our Employee Portal ("the Portal", "the Service"). 
              This Privacy Policy describes how we collect, use, process, store, and protect your personal information in compliance with applicable data protection laws, including but not limited to the General Data Protection Regulation (GDPR), the California Consumer Privacy Act (CCPA), and Israeli privacy laws.
            </p>
            <p style={{ marginTop: '15px' }}>
              By accessing or using the Portal, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy. If you do not agree with this Privacy Policy, please do not use the Portal.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              2. Data Controller and Contact Information
            </h2>
            <p style={{ marginBottom: '15px' }}>
              The data controller responsible for your personal information is:
            </p>
            <div style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '6px',
              borderLeft: `4px solid ${PRIMARY_RED}`,
              marginBottom: '15px'
            }}>
              <p style={{ marginBottom: '5px' }}>
                <strong>Bynet Data Centers Ltd.</strong>
              </p>
              <p style={{ marginBottom: '5px' }}>
                <strong>Email:</strong> Meir.Shuvax@bynetdcs.co.il
              </p>
              <p style={{ marginBottom: '5px' }}>
                <strong>Website:</strong> <a href="https://portal.bynetdcs.co.il" target="_blank" rel="noopener noreferrer">portal.bynetdcs.co.il</a>
              </p>
            </div>
            <p>
              For any questions, concerns, or requests regarding this Privacy Policy or your personal information, please contact us using the information provided above.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              3. Information We Collect
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We collect and process the following categories of personal information:
            </p>
            
            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              3.1. Personal Identifiers and Contact Information
            </h3>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Full name</li>
              <li style={{ marginBottom: '8px' }}>Email address</li>
              <li style={{ marginBottom: '8px' }}>Employee identification number</li>
              <li style={{ marginBottom: '8px' }}>Microsoft account identifier (for authentication)</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              3.2. Employment and Professional Information
            </h3>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Job title and position</li>
              <li style={{ marginBottom: '8px' }}>Department and organizational unit</li>
              <li style={{ marginBottom: '8px' }}>Organizational hierarchy and reporting structure</li>
              <li style={{ marginBottom: '8px' }}>Employment status</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              3.3. Profile and User-Generated Content
            </h3>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Profile picture and images</li>
              <li style={{ marginBottom: '8px' }}>Messages, comments, and communications</li>
              <li style={{ marginBottom: '8px' }}>Honors, awards, and recognition content</li>
              <li style={{ marginBottom: '8px' }}>Wishes, congratulations, and other user-generated content</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              3.4. Technical and Usage Information
            </h3>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>IP address and device identifiers</li>
              <li style={{ marginBottom: '8px' }}>Browser type and version</li>
              <li style={{ marginBottom: '8px' }}>Operating system</li>
              <li style={{ marginBottom: '8px' }}>Access logs and timestamps</li>
              <li style={{ marginBottom: '8px' }}>Usage patterns and interaction data</li>
              <li style={{ marginBottom: '8px' }}>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              4. Legal Basis for Processing
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We process your personal information based on the following legal grounds:
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>Contractual Necessity:</strong> Processing necessary for the performance of your employment contract and provision of the Portal services
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Legitimate Interests:</strong> Processing necessary for our legitimate business interests, including internal communications, employee recognition, and organizational management
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Legal Obligations:</strong> Processing required to comply with applicable laws, regulations, and legal processes
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Consent:</strong> Where you have provided explicit consent for specific processing activities
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              5. How We Use Your Information
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We use the collected information for the following purposes:
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>Service Provision:</strong> To provide, maintain, and improve the Portal services and functionality
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Authentication and Access Control:</strong> To verify your identity and manage access permissions
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Internal Communications:</strong> To facilitate communication between employees, including messages, updates, and notifications
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Employee Recognition:</strong> To manage and display honors, awards, and recognition programs
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Organizational Management:</strong> To maintain organizational charts, team structures, and employee directories
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Security and Fraud Prevention:</strong> To protect the Portal, detect security threats, and prevent unauthorized access
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Compliance:</strong> To comply with legal obligations, respond to legal requests, and enforce our policies
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Analytics and Improvement:</strong> To analyze usage patterns, improve user experience, and develop new features
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              6. Information Sharing and Disclosure
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We do not sell, rent, or trade your personal information to third parties for their marketing purposes. 
              We may share your information only in the following circumstances:
            </p>
            
            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              6.1. Service Providers and Business Partners
            </h3>
            <p style={{ marginBottom: '10px' }}>
              We may share information with trusted third-party service providers who assist us in operating the Portal, including:
            </p>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>
                <strong>Microsoft Corporation:</strong> For authentication services (Azure AD) and email communication (Microsoft Graph API)
              </li>
              <li style={{ marginBottom: '8px' }}>
                <strong>Cloud Hosting Providers:</strong> For data storage and infrastructure services (e.g., Render)
              </li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              These service providers are contractually obligated to protect your information and use it only for the purposes we specify.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              6.2. Legal Requirements
            </h3>
            <p style={{ marginBottom: '15px' }}>
              We may disclose information when required by law, court order, or governmental authority, or to:
            </p>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Comply with legal obligations and regulatory requirements</li>
              <li style={{ marginBottom: '8px' }}>Respond to valid legal process, including subpoenas and search warrants</li>
              <li style={{ marginBottom: '8px' }}>Protect our rights, property, or safety, or that of our employees or users</li>
              <li style={{ marginBottom: '8px' }}>Prevent or investigate fraud, security threats, or other illegal activities</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              6.3. Business Transfers
            </h3>
            <p>
              In the event of a merger, acquisition, reorganization, or sale of assets, your information may be transferred as part of the transaction, subject to the same privacy protections.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              7. Data Security
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We implement comprehensive technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction, including:
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>Encryption:</strong> Data encryption in transit (TLS/SSL) and at rest
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Access Controls:</strong> Multi-factor authentication, role-based access controls, and regular access reviews
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Network Security:</strong> Firewalls, intrusion detection systems, and regular security assessments
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Data Backup and Recovery:</strong> Regular backups and disaster recovery procedures
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Employee Training:</strong> Regular security awareness training for employees with access to personal information
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Incident Response:</strong> Procedures for detecting, reporting, and responding to security incidents
              </li>
            </ul>
            <p style={{ marginTop: '15px' }}>
              While we strive to protect your information, no method of transmission over the Internet or electronic storage is 100% secure. 
              We cannot guarantee absolute security but are committed to maintaining industry-standard protections.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              8. Your Rights and Choices
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Depending on your location and applicable law, you may have the following rights regarding your personal information:
            </p>
            
            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.1. Access and Portability
            </h3>
            <p style={{ marginBottom: '15px' }}>
              You have the right to request access to your personal information and receive a copy in a structured, commonly used, and machine-readable format.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.2. Rectification
            </h3>
            <p style={{ marginBottom: '15px' }}>
              You have the right to request correction of inaccurate or incomplete personal information.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.3. Erasure
            </h3>
            <p style={{ marginBottom: '15px' }}>
              You have the right to request deletion of your personal information, subject to legal retention requirements and our legitimate business interests.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.4. Restriction of Processing
            </h3>
            <p style={{ marginBottom: '15px' }}>
              You have the right to request restriction of processing of your personal information in certain circumstances.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.5. Objection to Processing
            </h3>
            <p style={{ marginBottom: '15px' }}>
              You have the right to object to processing of your personal information based on legitimate interests or for direct marketing purposes.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.6. Withdrawal of Consent
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Where processing is based on consent, you have the right to withdraw consent at any time, without affecting the lawfulness of processing based on consent before withdrawal.
            </p>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              8.7. Right to Lodge a Complaint
            </h3>
            <p>
              You have the right to lodge a complaint with a supervisory authority if you believe our processing of your personal information violates applicable data protection laws.
            </p>

            <div style={{ 
              backgroundColor: '#fff3cd', 
              padding: '15px', 
              borderRadius: '6px',
              borderLeft: `4px solid #ffc107`,
              marginTop: '20px'
            }}>
              <p style={{ margin: 0 }}>
                <strong>To exercise any of these rights, please contact us at:</strong> Meir.Shuvax@bynetdcs.co.il
              </p>
            </div>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              9. Cookies and Tracking Technologies
            </h2>
            <p style={{ marginBottom: '15px' }}>
              The Portal uses cookies and similar tracking technologies to enhance user experience, analyze usage patterns, and maintain security. 
              Cookies are small text files stored on your device when you visit the Portal.
            </p>
            
            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              9.1. Types of Cookies We Use
            </h3>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '8px' }}>
                <strong>Essential Cookies:</strong> Required for the Portal to function properly, including authentication and security
              </li>
              <li style={{ marginBottom: '8px' }}>
                <strong>Functional Cookies:</strong> Enable enhanced functionality and personalization
              </li>
              <li style={{ marginBottom: '8px' }}>
                <strong>Analytics Cookies:</strong> Help us understand how users interact with the Portal
              </li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '1.3rem', marginTop: '20px', marginBottom: '10px' }}>
              9.2. Managing Cookies
            </h3>
            <p>
              You can control cookies through your browser settings. However, disabling certain cookies may affect the functionality of the Portal. 
              Most browsers allow you to refuse or delete cookies, but doing so may limit your ability to use certain features.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              10. Third-Party Services and Links
            </h2>
            <p style={{ marginBottom: '15px' }}>
              The Portal integrates with the following third-party services:
            </p>
            <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>Microsoft Azure Active Directory:</strong> For user authentication and identity management. 
                Microsoft's privacy policy applies to their services: <a href="https://privacy.microsoft.com" target="_blank" rel="noopener noreferrer">https://privacy.microsoft.com</a>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Microsoft Graph API:</strong> For email communication and messaging services. 
                Subject to Microsoft's privacy policy and terms of service.
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>LinkedIn Integration (Read-Only):</strong> The Portal may display publicly available posts from the Company's official LinkedIn page.
                <p style={{ marginTop: '8px', marginBottom: '8px' }}>
                  This integration is strictly read-only. The system does not publish content, post on behalf of users, send data to LinkedIn, or perform any actions on the LinkedIn platform.
                </p>
                <p style={{ marginTop: '8px', marginBottom: '8px' }}>
                  No personal data from LinkedIn users is collected, stored, or processed by the Portal.
                </p>
                <p style={{ marginTop: '8px', marginBottom: '8px' }}>
                  Employees who click on a LinkedIn post are redirected to LinkedIn and interact with the content directly through their own LinkedIn accounts, subject to LinkedIn's own terms and privacy policy.
                </p>
                <p style={{ marginTop: '8px', marginBottom: '0' }}>
                  LinkedIn's privacy policy is available at: <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/legal/privacy-policy</a>
                </p>
              </li>
            </ul>
            <p>
              These third-party services have their own privacy policies and terms of service. We encourage you to review their privacy practices. 
              We are not responsible for the privacy practices of third-party services.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              11. Data Retention
            </h2>
            <p style={{ marginBottom: '15px' }}>
              We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. 
              Our retention periods are based on:
            </p>
            <ul style={{ paddingLeft: '20px' }}>
              <li style={{ marginBottom: '10px' }}>The purpose for which the information was collected</li>
              <li style={{ marginBottom: '10px' }}>Legal and regulatory requirements</li>
              <li style={{ marginBottom: '10px' }}>Legitimate business interests</li>
              <li style={{ marginBottom: '10px' }}>Statutes of limitations for potential legal claims</li>
            </ul>
            <p style={{ marginTop: '15px' }}>
              When personal information is no longer needed, we will securely delete or anonymize it in accordance with our data retention policies and applicable law.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              12. International Data Transfers
            </h2>
            <p>
              Your personal information may be transferred to and processed in countries other than your country of residence. 
              These countries may have data protection laws that differ from those in your jurisdiction. 
              We ensure that appropriate safeguards are in place to protect your information, including standard contractual clauses and other mechanisms approved by applicable data protection authorities.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              13. Children's Privacy
            </h2>
            <p>
              The Portal is intended for use by employees and authorized personnel only. We do not knowingly collect personal information from individuals under the age of 18. 
              If we become aware that we have collected information from a minor, we will take steps to delete such information promptly.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              14. Changes to This Privacy Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. 
              We will notify you of material changes by posting the updated Privacy Policy on the Portal and, where appropriate, through other communication channels. 
              Your continued use of the Portal after such changes constitutes acceptance of the updated Privacy Policy. 
              We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              15. Contact Us
            </h2>
            <p style={{ marginBottom: '15px' }}>
              If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
            </p>
            <div style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '20px', 
              borderRadius: '6px',
              borderLeft: `4px solid ${PRIMARY_RED}`
            }}>
              <p style={{ marginBottom: '10px' }}>
                <strong>Bynet Data Centers Ltd.</strong>
              </p>
              <p style={{ marginBottom: '5px' }}>
                <strong>Email:</strong> Meir.Shuvax@bynetdcs.co.il
              </p>
              <p style={{ marginBottom: '5px' }}>
                <strong>Website:</strong> <a href="https://portal.bynetdcs.co.il" target="_blank" rel="noopener noreferrer">portal.bynetdcs.co.il</a>
              </p>
            </div>
            <p style={{ marginTop: '15px' }}>
              We will respond to your inquiry within a reasonable timeframe and in accordance with applicable law.
            </p>
          </section>

          <section>
            <h2 style={{ color: PRIMARY_RED, fontSize: '1.8rem', marginBottom: '15px' }}>
              16. Consent and Acknowledgment
            </h2>
            <p>
              By using the Employee Portal, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and processing of your personal information as described herein. 
              If you do not agree with this Privacy Policy, please do not use the Portal and contact us to discuss your concerns.
            </p>
          </section>

        </div>

        {/* Footer */}
        <div style={{ 
          marginTop: '40px', 
          paddingTop: '20px', 
          borderTop: '1px solid #e0e0e0',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px'
        }}>
          <p>© {new Date().getFullYear()} Bynet Data Centers Ltd. All rights reserved.</p>
        </div>
      </div>
    </Container>
  );
};

export default PrivacyPolicy;
